module.exports = __webpack_public_path__ + "img/mortgages-main.fd3ae35.webp";